if (!customElements.get('product-gallery')) {
  class ProductGallery extends window.BaseComponent {
    constructor() {
      super();
    }

    init() {
      this.sectionId = this.dataset.section;
      this.initSwiper();
      this.initPagination();
      this.initThumbnails();

      // Listen for variant changes to slide gallery
      if (window.pubsub) {
        window.pubsub.subscribe('variant-change', (variant) => {
          if (variant && variant.featured_media) {
            this.slideToMedia(variant.featured_media.id);
          }
        });
      }
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') {
        console.error('Swiper not found. Media gallery requires Swiper bundle.');
        return;
      }

      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) {
        console.warn('ProductGallery: No .swiper container found.');
        return;
      }

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        autoHeight: true,
        on: {
          slideChange: () => {
            this.updatePagination(this.swiper.activeIndex);
            this.updateThumbnails(this.swiper.activeIndex);
            // Swiper autoHeight changes container height — tell Lenis
            this.refreshLenis();
          }
        }
      });
    }

    initPagination() {
      this.pagination = document.querySelector(`.dot-pagination[data-pagination-for="${this.sectionId}"]`);
      if (!this.pagination) return;

      this.dots = this.pagination.querySelectorAll('.dot-pagination__dot');
      this.prevBtn = this.pagination.querySelector('.dot-pagination__arrow--prev');
      this.nextBtn = this.pagination.querySelector('.dot-pagination__arrow--next');

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index);
          this.swiper.slideTo(index);
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.swiper.slidePrev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.swiper.slideNext());
      }
    }

    initThumbnails() {
      this.thumbnailsWrapper = document.querySelector('.product__thumbnails');
      if (!this.thumbnailsWrapper) return;

      this.thumbs = this.thumbnailsWrapper.querySelectorAll('.product__thumbnail-item');
      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const index = parseInt(thumb.dataset.index);
          this.swiper.slideTo(index);
        });
      });
    }

    updatePagination(index) {
      if (!this.dots) return;
      this.dots.forEach(dot => {
        dot.classList.toggle('is-active', parseInt(dot.dataset.index) === index);
      });
    }

    updateThumbnails(index) {
      if (!this.thumbs) return;
      this.thumbs.forEach(thumb => {
        thumb.classList.toggle('is-active', parseInt(thumb.dataset.index) === index);
      });
    }

    slideToMedia(mediaId) {
      const targetSlide = this.querySelector(`.swiper-slide[data-media-id="${mediaId}"]`);
      if (targetSlide) {
        const index = [...this.querySelectorAll('.swiper-slide')].indexOf(targetSlide);
        if (index !== -1) {
          this.swiper.slideTo(index);
          this.refreshLenis();
        }
      }
    }

    /**
     * Notify Lenis that content dimensions have changed.
     * Waits for Swiper's autoHeight CSS transition (300ms) to complete.
     */
    refreshLenis() {
      if (this._lenisTimer) clearTimeout(this._lenisTimer);
      this._lenisTimer = setTimeout(() => {
        if (window.lenis) window.lenis.resize();
      }, 350);
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  if (window.BaseComponent) {
    customElements.define('product-gallery', ProductGallery);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.BaseComponent) customElements.define('product-gallery', ProductGallery);
    });
  }
}
